import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Row, Col, Button, Card, CardBody, CardHeader, Collapse, Modal, ModalHeader, ModalBody, ModalFooter, Input ,Label} from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import uuid from 'react-uuid';
import toast, { Toaster } from 'react-hot-toast';
import moment from "moment";
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer'; import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const OrganisationSummary = () => {
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const [loading, setLoading] = useState(true);
    const [organiationSummary, setOrganiationSummary] = useState({ summaryList: [] });
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/EnterpriseInsights/GetOrganisationSummaryList/', {
                params: {
                    UserId: userId
                }
            }
            );
            setOrganiationSummary({
                ...organiationSummary, summaryList: response.data
            });
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    }
    const [associateLoading, setAssociateLoading] = useState(false);
    const [accessList, setAccessList] = useState([]);
    const [associateList, setAssociateList] = useState([]);
    const [popup, setPopup] = useState({ showPopup: false, popupTitle: 'Add Action',consultant:'',viewAccessList:false,accessList:[],associateList:[]});
    const handleHidePopup = () => {
        setPopup({ showPopup: false, id: 0 });
    }
    const handleShowPopup = async (consultant, organisationSummaryConsultantList, userFarmList) => {
        setAssociateLoading(true);
        setPopup({ showPopup: true, consultant: consultant, popupTitle: 'Allocated Property List for ' + consultant });
        setAssociateList(organisationSummaryConsultantList);
        setAccessList(userFarmList);
    }
    const handleViewAccessList = async (e) => {
        const { name, value, checked, type } = e.target;
        setPopup({ ...popup, viewAccessList: checked, popupTitle: checked == true ? 'Access Property List for ' + popup.consultant : 'Allocated Property List for ' + popup.consultant })
    }

    const exportAssociateListToExcel = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportAssociateList();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }
    const exportActionListToExcel = async (e, consultant) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportActionList(consultant);
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }
    const handleExportActionList = async (consultant) => {
        let form = {
            UserId: userId,
            Consultant: consultant
        };
        const response = await apiPost(
            '/api/EnterpriseInsights/ExportActionList/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "OrganisationSummary_OpenActions_" + consultant + ".xlsx";
            document.body.appendChild(link)
            link.click()
        }
    }
    const handleExportAssociateList = async () => {
        let form = {
            AssociateList: [],
            Consultant: popup.consultant
        };
        for (var i = 0; i < associateList.length; i++) {
            var obj = {};
            obj.UniqueIdentifier = associateList[i].uniqueIdentifier;
            obj.CreatedOnString = associateList[i].createdOnString;
            obj.FarmName = associateList[i].farmName;
            obj.FarmOperator = associateList[i].farmOperator;
            obj.OpenActions = associateList[i].openActions;
            obj.LastUpdatedOnString = associateList[i].lastUpdatedOnString;
            obj.Status = associateList[i].status;
            form.AssociateList.push(obj);
        }
        const response = await apiPost(
            '/api/EnterpriseInsights/ExportAssociateList/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "AssociateList_" + popup.consultant +".xlsx";
            document.body.appendChild(link)
            link.click()
        }
    }
    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
    return (<div>
        
                    <Card className="my-4">
            <CardHeader className="card-header-dark-click" onClick={toggle}>
                <Row>
                    <Col sm="11"><h6>Organisation Summary - Team Members & Properties
                    </h6></Col>
                    <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody >
                    
                    {loading ? <> <br /> <br /><SpinnerContainer /></> :
                        <div>
                            <Row>
                        <Col>
                            {!loading &&
                                <table id="tblWaterwayFencingSummary" className="table borderless table-striped border-top-bottom">
                                    <thead className="text-left">
                                        <tr>
                                            <th style={{width:"40%"}}>Consultant</th>
                                            <th style={{width:"15%"}}># Allocated Properties</th>
                                            <th style={{width:"15%"}}>View Property List</th>
                                            <th style={{width:"15%"}}># Open Actions</th>
                                            <th style={{width:"15%"}}>Export Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="waterwayFencingSummaryList text-left" id="waterwayFencingSummaryList">
                                        {organiationSummary.summaryList != undefined && organiationSummary.summaryList.length > 0 && organiationSummary.summaryList.map(summary =>

                                            <tr key={uuid()}>
                                                <td>{summary.consultant}</td>
                                                <td style={{ textAlign: "center" }}>{summary.allocatedProperties == 0 ? '' : summary.allocatedProperties}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    <button style={{ fontSize: "11px" }} type="button"
                                                        onClick={(e) => handleShowPopup(summary.consultant, summary.organisationSummaryConsultantList, summary.userFarmList)}
                                                        className="btn btn-success btn-sm">
                                                        View
                                                    </button>
                                                </td>
                                                <td style={{ textAlign: "center" }}>{summary.openActions == 0 ? '' : summary.openActions}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    <Button style={{ background: "none", border: "none" }} onClick={(e) => exportActionListToExcel(e, summary.consultant)} value="Export" placeholder="">
                                                        <img src="/images/Excel_icon.png" className="card_icon" ></img>
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th style={{ width: "40%" }}><b>Total</b></th>
                                            <th style={{ width: "15%", textAlign: "center" }}>{organiationSummary.summaryList != undefined && organiationSummary.summaryList.length > 0 && organiationSummary.summaryList.map(data => parseInt(data.allocatedProperties)).reduce((a, b) => parseInt(a) + parseInt(b))}</th>
                                            <th style={{ width: "15%" }}></th>
                                            <th style={{ width: "15%", textAlign: "center" }}>{organiationSummary.summaryList != undefined && organiationSummary.summaryList.length > 0 && organiationSummary.summaryList.map(data => parseInt(data.openActions)).reduce((a, b) => parseInt(a) + parseInt(b))}</th>
                                            <th style={{ width: "15%" }}></th>
                                        </tr>
                                    </tfoot>
                                </table>
                            }
                        </Col>
                    </Row>
                        </div>}
                </CardBody>
            </Collapse>
                </Card>
                
        <Modal size="lg" style={{ maxWidth: '50vw', width: '100%' }} isOpen={popup.showPopup}>
            <ModalHeader toggle={handleHidePopup} >{popup.popupTitle}</ModalHeader>
            <ModalBody>
                        <Row>
                            <Col sm="8">
                                {!popup.viewAccessList &&
                                    <span>These properties are directly associated with the consultant</span>
                                }
                                {popup.viewAccessList &&
                                    <span>List of properties accessible by the consultant<br />(Note: List may be different than the directly allocated list)</span>
                                }
                            </Col>
                            {!popup.viewAccessList &&
                                <Col sm="1">
                            <Button style={{ float: "right", background: "none", border: "none" }} onClick={(e) => exportAssociateListToExcel(e)} value="Export" placeholder="">
                                        <img src="/images/Excel_icon.png" className="card_icon" ></img>
                                    </Button>
                                </Col>
                            }
                            {
                                popup.viewAccessList && <Col sm="1"></Col>
                            }
                            <Col sm="3">
                                <Input type="checkbox" checked={popup.viewAccessList} onChange={(e) => handleViewAccessList(e)} name="viewAccessList" id="viewAccessList" />&nbsp;&nbsp;&nbsp;
                                <Label>View Access List</Label>
                            </Col>
                        </Row>
                        <br />
                <Row>
                    <Col>
                        {!popup.viewAccessList &&
                            <Col>
                                <table id="tblWaterwayFencingSummary1" className="table borderless table-striped border-top-bottom">
                                    <thead className="text-left">
                                        <tr>
                                            <th style={{ width: "20%" }}>Name</th>
                                            <th style={{ width: "15%" }}>Farm Operator</th>
                                            <th style={{ width: "15%" }}>Farm Identifier</th>
                                            <th style={{ width: "12%" }}>Created On</th>
                                            <th style={{ width: "12%" }}>Last Updated On</th>
                                            <th style={{ width: "12%" }}>Status</th>
                                            <th style={{ width: "12%" }}># Open Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="waterwayFencingSummaryList text-left" id="waterwayFencingSummaryList">
                                        {associateList != undefined && associateList.length > 0 && associateList.map(summary =>

                                            <tr key={uuid()}>
                                                <td>{summary.farmName}</td>
                                                <td>{summary.farmOperator}</td>
                                                <td>{summary.uniqueIdentifier}</td>
                                                <td>{summary.createdOn != null ? moment(summary.createdOn).format("DD/MM/YYYY") : ""}</td>
                                                <td>{summary.lastUpdatedOn != null ? moment(summary.lastUpdatedOn).format("DD/MM/YYYY") : ""}</td>
                                                <td>{summary.status}</td>
                                                <td>{summary.openActions}</td>
                                            </tr>
                                        )
                                        }
                                    </tbody>
                                </table>
                            </Col>
                            
                        }
                        {popup.viewAccessList &&
                            <Col>
                                <table id="tblWaterwayFencingSummary2" className="table borderless table-striped border-top-bottom">
                                    <thead className="text-left">
                                        <tr>
                                            <th style={{ width: "60%" }}>Farm Name</th>
                                            <th style={{ width: "40%" }}>Unique Identifier</th>
                                        </tr>
                                    </thead>
                                    <tbody className="waterwayFencingSummaryList text-left" id="waterwayFencingSummaryList">
                                        {accessList != undefined && accessList.length > 0 && accessList.map(summary =>
                                            <tr key={uuid()}>
                                                <td>{summary.farmname}</td>
                                                <td>{summary.farmUniqueIdentifier}</td>
                                            </tr>
                                        )
                                        }
                                    </tbody>
                                </table>
                            </Col>
                            
                        }
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={handleHidePopup}>Cancel</Button>
            </ModalFooter>
        </Modal>
    </div>
    )
}
export default OrganisationSummary

